import type {
  PermissionsAdmin,
  PermissionsAffiliate,
  PermissionsAnonymous,
} from '../types';

export default class Permission {
  protected admin?: PermissionsAdmin;

  protected affiliate?: PermissionsAffiliate;

  protected anonymous?: PermissionsAnonymous;

  constructor(admin?: PermissionsAdmin, affiliate?: PermissionsAffiliate, anonymous?: PermissionsAnonymous) {
    this.admin = admin;
    this.affiliate = affiliate;
    this.anonymous = anonymous;
  }

  getAdminPermission(): PermissionsAdmin | undefined {
    return this.admin;
  }

  getAffiliatePermission(): PermissionsAffiliate | undefined {
    return this.affiliate;
  }

  getAnonymousPermission(): PermissionsAnonymous | undefined {
    return this.anonymous;
  }

  toString(): string {
    return `${this.admin}:${this.affiliate}:${this.anonymous}`;
  }
}
